import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import "@/App.css";
import Home from "@/pages/Home";
import Museum from "@/pages/Museum";
import CorteMiniera from "@/pages/CorteMiniera";
import Servizi from "@/pages/Servizi";
import Progetti from "@/pages/Progetti";
import ProgettiSartoriali from "@/pages/ProgettiSartoriali";
import Prenota from "@/pages/Prenota";
import Contatti from "@/pages/Contatti";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Admin from "@/pages/Admin";
import ConfermaOpzione from "@/pages/ConfermaOpzione";
import Ospiti from "@/pages/Ospiti";
import { AuthProvider } from "@/context/AuthContext";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  // Handle Emergent auth callback via URL fragment BEFORE routing
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/museum-graphia" element={<Museum />} />
      <Route path="/corte-della-miniera" element={<CorteMiniera />} />
      <Route path="/servizi" element={<Servizi />} />
      <Route path="/progetti" element={<Progetti />} />
      <Route path="/progetti-sartoriali" element={<ProgettiSartoriali />} />
      <Route path="/prenota" element={<Prenota />} />
      <Route path="/contatti" element={<Contatti />} />
      <Route path="/login" element={<Login />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/admin/prenotazioni" element={<Admin />} />
      <Route path="/conferma-opzione/:bookingId/:token" element={<ConfermaOpzione />} />
      <Route path="/ospiti/:bookingId/:token" element={<Ospiti />} />
    </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
